function formatDate(timestamp) {
  const date = new Date(timestamp);
  return date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export default formatDate;

export const getReducedText = (myText) => {
  /** This function returns reduced text
   *  For specific length
   *  */

  const textLengthToConsider = 200;

  if (myText?.length <= textLengthToConsider) return myText;

  // get the first 100 characters
  const startText = myText?.slice?.(0, 100);

  const endTextLength = myText?.length - 100;

  // get the last characters
  const endText = myText?.slice(endTextLength, 100);

  const finalText = startText + "..." + endTextLength;

  return finalText;
};
